var module = angular.module('octopusApp.master');

module.directive('gettingStartedDetailSection', [function () {
    return {
        templateUrl: 'areas/master/getting-started/views/getting_started_detail_section.html',
        restrict: 'E',
        transclude: true,
        replace: true,
        scope: {
            header: '@',
            area: '@',
            imgSrc: '@',
            complete: '=complete'
        },
        link: function (scope, element) {
            angular.element(element.children()[0]).css('display', scope.complete === true ? 'inherit' : 'none');

            scope.areaId = scope.area.replace(' ', '_');

            scope.$watch('complete', function(newVal, oldVal) {
                if (newVal) {
                    angular.element(element.children()[0]).css('display', scope.complete === true ? 'inherit' : 'none');
                }
            });

        }
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./app/areas/master/getting-started/directives/getting_started_detail_section.js
// module id = 3677973636301725
// module chunks = 1